import { Store } from 'vuex';
import { Actions, Context } from 'vuex-smart-module';
import ClientsStore from '../../store';
import ClientsState from '../../store/state';
import ClientsSharedGetters from './getters';
import ClientsSharedMutations from './mutations';
import ClientsSharedState from './state';

export default class ClientsSharedActions extends Actions<
  ClientsSharedState,
  ClientsSharedGetters,
  ClientsSharedMutations,
  ClientsSharedActions
> {
  clients_store!: Context<typeof ClientsStore>;

  $init(store: Store<ClientsState>): void {
    this.clients_store = ClientsStore.context(store);
  }

  get_clients(max_request_limit?: number) {
    return this.clients_store.actions.get_clients(max_request_limit);
  }
}
